import { render, staticRenderFns } from "./brandFeedback.vue?vue&type=template&id=b7c1ec00&scoped=true"
import script from "./brandFeedback.vue?vue&type=script&lang=js"
export * from "./brandFeedback.vue?vue&type=script&lang=js"
import style0 from "./brandFeedback.vue?vue&type=style&index=0&id=b7c1ec00&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7c1ec00",
  null
  
)

export default component.exports